import React from 'react';
import Image from 'next/image';

export interface FullWidthImageMosaicProps {
  largeImageWrapper: {
    jsonBynderAsset: {
      originalUrl: string;
    };
    altText?: string;
  };
  firstSmallImageWrapper: {
    jsonBynderAsset: {
      originalUrl: string;
    };
    altText?: string;
  };
  secondSmallImageWrapper: {
    jsonBynderAsset: {
      originalUrl: string;
    };
    altText?: string;
  };
  topBlock?: boolean;
}

const EditorialFullWidthImageMosaicBlock = ({
  largeImageWrapper,
  firstSmallImageWrapper,
  secondSmallImageWrapper,
  topBlock,
}: FullWidthImageMosaicProps) => {
  const imageCss =
    'rounded-card-mobile mx-auto transform-gpu ' +
    (largeImageWrapper
      ? 'aspect-1/0.75 lg:max-h-none max-h-[860px] w-full lg:max-w-none max-w-[645px] '
      : 'aspect-1.5/1 max-h-[430px] max-w-[645px] ');

  return (
    <div
      className={
        'flex flex-col items-center gap-5 px-5 sm:flex-row sm:items-start sm:gap-4 sm:px-0 ' +
        (topBlock ? 'pt-5 lg:pt-0 ' : 'lg:my-5 ')
      }
    >
      {largeImageWrapper?.jsonBynderAsset?.originalUrl && (
        <div className={imageCss + 'relative overflow-hidden'}>
          <Image
            src={largeImageWrapper?.jsonBynderAsset?.originalUrl}
            alt={largeImageWrapper?.altText || 'alt text not found'}
            width={1200}
            height={1500}
            className={`object-cover w-full lg:h-[685px] h-[466px]`}
          />
        </div>
      )}
      <div className="flex w-full flex-col gap-5 sm:gap-4">
        {firstSmallImageWrapper?.jsonBynderAsset?.originalUrl && (
          <div
            className={
              'rounded-card-mobile mx-auto transform-gpu aspect-1.5/1 max-h-[430px] max-w-[645px] ' +
              'relative overflow-hidden'
            }
          >
            <Image
              src={firstSmallImageWrapper?.jsonBynderAsset?.originalUrl}
              alt={firstSmallImageWrapper?.altText || 'alt text not found'}
              width={1500}
              height={1000}
              className="object-cover w-full h-full"
            />
          </div>
        )}
        {secondSmallImageWrapper?.jsonBynderAsset?.originalUrl && (
          <div
            className={
              'rounded-card-mobile mx-auto transform-gpu aspect-1.5/1 max-h-[430px] max-w-[645px] ' +
              'relative overflow-hidden'
            }
          >
            <Image
              src={secondSmallImageWrapper?.jsonBynderAsset?.originalUrl}
              alt={secondSmallImageWrapper?.altText || 'alt text not found'}
              width={1500}
              height={1000}
              className="object-cover w-full h-full"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditorialFullWidthImageMosaicBlock;
